import { render, staticRenderFns } from "./promo-view.vue?vue&type=template&id=3a455ee8&scoped=true"
import script from "./promo-view.vue?vue&type=script&lang=js"
export * from "./promo-view.vue?vue&type=script&lang=js"
import style0 from "./promo-view.vue?vue&type=style&index=0&id=3a455ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a455ee8",
  null
  
)

export default component.exports